export const customizeRequiredMark = (label: React.ReactNode, { required }: { required: boolean }) => (
  <>
    {label}
    {required && <span style={{ color: "red", marginLeft: "3px" }}>*</span>}
  </>
);